import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class MessageService {

    // todo: trocar para Subject

    private _subjects: { [ID: string]: Subject<any> } = {};

    get(ID: string): Subject<any> {

        if (!this._subjects[ID]) {
            this._subjects[ID] = new Subject();
        }

        return this._subjects[ID];

    }

}

/*

 export class MessageService {
 private subject = new Subject<any>();

 sendMessage(message: string) {
 this.subject.next({ text: message });
 }

 clearMessage() {
 this.subject.next();
 }

 getMessage(): Observable<any> {
 return this.subject.asObservable();
 }
 }

 */



// WEBPACK FOOTER //
// ./src/providers/message-service.ts